import jsPDF from "jspdf";




const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });




export const GenerateReceipt = async (data) => {
  const doc = new jsPDF();
//Address
//Behind Shreeji Sky, Nr. Shyam 42, Opp. Lambha Temple, Laxmipura, Lambha, Ahmedabad, Gujarat, India - 382440

 /*const logo = await fetch("../public/KananLogo.png")
    .then(res => res.blob())
    .then(blob => new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    }));*/

  

    //logo
     const img = await loadImage("/KananLogo.png");

  // Logo
  doc.addImage(img, "PNG", 20, 10, 40, 20);

/*
// Vertical line between columns
doc.line(140, 88, 140, 123);

// Table Header
doc.rect(15, 88, 180, 10);
doc.setFont("helvetica", "bold");
doc.text("Description", 20, 95);
doc.text("Amount (₹)", 185, 95, { align: "right" });



*/





  // Title
  
   doc.setFontSize(11);
    doc.text("Reg.No. REG/AHD/SA(HA)-22113", 130, 15);

    doc.setFontSize(20);
    doc.setTextColor(255,0,0);
    doc.text("Kanan Residency", 80, 20);

    doc.setFontSize(11);
    doc.setTextColor(0,0,0);
    doc.text("Behind Shreeji Sky, Nr. Shyam 42, Opp. Lambha Temple, ", 65, 25);
    doc.text("Lambha, Ahmedabad, Gujarat, India - 382440", 80, 30);
    doc.line(20, 32, 190, 32);


    doc.setFontSize(16);
    doc.setTextColor(0,0,0);
    doc.text("Receipt", 20, 40);

    doc.setFontSize(11);
    doc.text(`Receipt No: ${data.receiptNo}`, 20, 45);
    doc.text(`Date: ${new Date().toLocaleString()}`, 20, 50);

    doc.line(20, 52, 190, 52);

    // User details
    doc.text(`Name: ${data.name}`, 20, 70);
    doc.text(`Flat No: ${data.flat}`, 20, 80);
    doc.text(`Mobile: ${data.mobile}`, 20, 90);

    doc.line(20, 92, 190, 92);

    // Payment details
    doc.text(`Payment Mode: ${data.mode}`, 20, 110);
    doc.text(`Amount Paid: ₹${data.amount}`, 20, 120);
    doc.text(`Transaction ID: ${data.txnId}`, 20, 130);

    doc.line(20, 132, 190, 132);

    doc.text("Thank you for your payment!", 20, 140);
    doc.text("This is a system generated receipt.", 20, 150);

    // Download PDF
    doc.save(`receipt_${data.receiptNo}.pdf`);
};
